import React, { Component } from 'react';
import AuthTokenService from '../service/authTokenService';

import "../design/loginform.css";
import NavigationBar from '../components/navigationBar';
import AuthorizationHelper from '../helper/AuthorizationHelper';


export default class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userName: "",
            password: ""
        }

        this.handleChange = this.handleChange.bind(this);
        this.authTokenService = new AuthTokenService();
        this.authorizationHelper = new AuthorizationHelper();
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    componentDidMount() {
        document.title = "Login";
    }

    async onSubmitClick(event) {
        event.preventDefault();
        if(!await this.authorizationHelper.loginUser(this.state.userName, this.state.password)){
            this.props.history.push("/Login")
            return;
        }

        this.props.history.push("/");
    }

    render() {
        return (
            <div className="body">
                <NavigationBar {...this.props} />

                <main>

                    <div id="LoginDiv" className='content'>
                        <form action="#" onSubmit={(event) => { this.onSubmitClick(event) }}>
                            <label className="labelLoginForm" htmlFor="userName">Username:</label>
                            <input className="loginInputLabel" type="text" name="userName" placeholder="Enter your username." value={this.state.userName} onChange={this.handleChange} required /><br />
                            <label className="labelLoginForm" htmlFor="password">Password:</label>
                            <input className="loginInputLabel" type="password" name="password" placeholder="Enter your password" value={this.state.password} onChange={this.handleChange} required /><br />
                            <button className="buttonLoginSubmit" type="submit">Login</button>
                        </form>
                    </div>
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/login.js